import { colors } from '../../../styles/theme';
import {
  historyCardActionsSx,
  historyCardHeaderSx,
  historyCardSx,
  historyCardsStackSx,
  historyHeaderZoneSx,
  historyPaperSx,
  historyScrollZoneSx,
  historySkeletonMutedSx,
  historySkeletonPrimarySx,
  historyToolbarZoneSx,
} from '../HistoryPanel/HistoryPanel.styles';

/**
 * Resultados: mismos tokens que Historial / Registros (paper, zonas, card,
 * skeleton). Solo se agregan los ajustes propios del panel.
 */
export const panelPaperSx = historyPaperSx;
export const headerZoneSx = historyHeaderZoneSx;
export const toolbarZoneSx = historyToolbarZoneSx;
/** Sin buscador: solo la fila de totales (y el aviso de muestra). */
export const toolbarBoxSx = { px: 2.5, pt: 1.5, pb: 1.5 };
export const scrollZoneSx = historyScrollZoneSx;
export const cardsStackSx = historyCardsStackSx;
export const filterResultCardSx = historyCardSx;
export const filterResultCardHeaderSx = historyCardHeaderSx;
export const filterResultCardActionsSx = historyCardActionsSx;
export const skeletonPrimarySx = historySkeletonPrimarySx;
export const skeletonMutedSx = historySkeletonMutedSx;

export const sampleHintSx = {
  mt: 1,
  color: colors.textSecondary,
  fontSize: '12px',
  lineHeight: '16px',
};

export const moreHintSx = {
  textAlign: 'center',
  py: 1,
  fontSize: '11.5px',
  color: colors.textSecondary,
};

export const spinnerSlotSx = {
  width: 14,
  height: 14,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const refreshingSpinnerSx = { color: colors.primary };
